import { DeliveryLineStatus } from '@common/enums';

export const booleanToDeliveryLineStatus = (value: boolean): DeliveryLineStatus => {
    return value ? DeliveryLineStatus.VERIFIED : DeliveryLineStatus.DELIVERED;
};

export const deliveryLineStatusToBoolean = (status: DeliveryLineStatus): boolean => {
    return status === DeliveryLineStatus.VERIFIED;
};
